import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import gql from 'graphql-tag';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { familia } from 'src/app/shared/object/familia.model';
import { formato } from 'src/app/shared/object/formato.model';
import { impuesto } from 'src/app/shared/object/impuesto.model';
import { lista_precio_detalle } from 'src/app/shared/object/lista_precio_detalle.model';
import { producto } from 'src/app/shared/object/producto.model';
import { producto_formatoJoin } from 'src/app/shared/object/producto_formatoJoin.model';
import { producto_impuesto } from 'src/app/shared/object/producto_impuesto.model';
import { producto_impuestoJoin } from 'src/app/shared/object/producto_impuestoJoin.model';
import { rubro } from 'src/app/shared/object/rubro.model';
import { unidad_medida } from 'src/app/shared/object/unidad_medida.model';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { ToastService } from 'ng-uikit-pro-standard';
import { ConsoleService } from "src/app/shared/services/console.service";

@Component({
  selector: 'app-producto-modal-volumen-peso',
  templateUrl: './modal-volumen-peso.component.html',
  styleUrls: ['../productos.component.scss'],
  providers: [SecurityService, ValidadoresService]
})
export class ProductoModalVolumenPesoComponent implements OnInit {

  @Output() onVolumenPesoSeleccionado: EventEmitter<any> = new EventEmitter<any>()

  private client: GraphQLClient = null;

  // Modales
  @ViewChild('editarPesoVolumen', { static: true }) editarPesoVolumenModal: ModalDirective;

  formPesoVolumen: FormGroup;

  public rut_empresa: number;
  formatoCodigoOriginal: any

  // Utils
  private log: any

  constructor(
    client: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private formBuilder: FormBuilder,
    private clog: ConsoleService,
  ) {
    this.client = client;
    this.log = this.clog.log('PRODUCTOS-ADD/EDIT / FORMATOS')
  }

  ngOnInit() {
    this.rut_empresa = Number(this.accesolocalstorage.getRutEmpresa());

    this.createForm()
  }

  createForm() {
    this.formPesoVolumen = this.formBuilder.group({
      peso: ['', [Validators.required, Validators.min(1)]],
      volumen: ['', [Validators.required, Validators.min(1)]],
    });
  }

  loadAndShow({ formato_codigo, peso_neto, volumen }) {
    this.formatoCodigoOriginal = formato_codigo
    this.formPesoVolumen.get('peso').setValue(peso_neto);
    this.formPesoVolumen.get('volumen').setValue(volumen);
    this.editarPesoVolumenModal.show()
  }

  guardarPesoVolumen() {
    this.onVolumenPesoSeleccionado.emit({ ...this.formPesoVolumen.value, formato_codigo: this.formatoCodigoOriginal })
    this.editarPesoVolumenModal.hide()
  }

}
